var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, computed, makeObservable } from 'mobx';
import { Reaction } from '../../../utils/mobx/Reaction';
import { flatten, uniq } from '../../../utils/helper/lodash_replacements';
export class Mutator {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
        this.mutationTrigger = new Reaction({
            when: () => this.nextMutation,
            action: this.runNextMutation,
            name: 'mutationTrigger',
            setupWhenIdle: true,
        });
    }
    mutationTrigger;
    get director() {
        return this.parent;
    }
    get app() {
        return this.parent.parent;
    }
    get mutators() {
        const holders = uniq([...this.app.exportingTree.allExportingActors, ...this.app.importingTree.allImportingActors]);
        return holders;
    }
    get allMutations() {
        if (!this.app.appBoot.isInteractive)
            return [];
        return flatten(this.mutators.map(actor => (actor.mutability ? actor.entityMutation.activeMutations : [])));
    }
    get pendingMutations() {
        return this.allMutations.filter(mutation => mutation.isMutationPending);
    }
    get nextMutation() {
        return this.allMutations.find(mutation => mutation.isMutationPending);
    }
    runNextMutation() {
        if (!this.nextMutation)
            return;
        this.nextMutation.runMutation();
    }
}
__decorate([
    computed
], Mutator.prototype, "mutators", null);
__decorate([
    computed
], Mutator.prototype, "pendingMutations", null);
__decorate([
    computed
], Mutator.prototype, "nextMutation", null);
__decorate([
    action.bound
], Mutator.prototype, "runNextMutation", null);
